import React from 'react';
import Navbar from '@/components/Navbar';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-5xl font-bold text-center mb-12 bg-gradient-to-r from-teal-500 to-pink-500 bg-clip-text text-transparent">
          About the Artist
        </h1>
        
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-testid="about-content">
          <div className="md:flex">
            <div className="md:w-1/2">
              <img 
                src="https://images.unsplash.com/photo-1604871000636-074fa5117945?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxmbHVpZCUyMGFydHxlbnwwfHx8fDE3NjEyNDgzOTd8MA&ixlib=rb-4.1.0&q=85"
                alt="Artist"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="md:w-1/2 p-8 md:p-12">
              <h2 className="text-3xl font-bold mb-6 text-gray-900">The Journey</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Welcome to Fluid Fusion AZ, where art comes alive through the dance of color and motion. 
                  My journey began with a simple fascination: watching paint flow, merge, and create 
                  unexpected beauty.
                </p>
                <p>
                  Each piece I create is a meditation on emotion and movement. Through fluid art techniques, 
                  I explore the intersection of control and chaos, allowing colors to blend and interact in 
                  ways that mirror the complexity of human experience.
                </p>
                <p>
                  My work spans fluid art, abstract paintings, and fine art photography—each medium offering 
                  a unique way to capture the ephemeral moments that define beauty. Whether it's the vibrant 
                  swirls of acrylic pour or the stark elegance of black and white photography, my goal is to 
                  create pieces that resonate on a visceral level.
                </p>
                <p className="font-semibold text-teal-600">
                  Art is not just what we see—it's what we feel in the spaces between colors, 
                  in the flow of forms, and in the moments of stillness.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;